import script from "./BiddingActions.vue?vue&type=script&setup=true&lang=js"
export * from "./BiddingActions.vue?vue&type=script&setup=true&lang=js"

import "./BiddingActions.vue?vue&type=style&index=0&id=1bdd2868&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bdd2868"]])

export default __exports__